import styled from 'styled-components';
import { ShippingDetailsDTO } from '../../data/ShippingDetailsDTO';
import { useCallback, useState } from 'react';
import { PricingInsightsResultDTO } from '../../data/CarrierPayDTO';
import {
  isEmptyFormValues,
  ShippingDetailsForm,
  useShippingDetailsQueryParams,
} from './shipping-details/ShippingDetailsForm';
import { PricingRecommendation } from './price-recommendation/PricingRecommendation';
import { useUnlockUtils } from './unlock/UnlockUtils';
import {
  PRICING_INSIGHTS_DEMO_DATA,
  PRICING_INSIGHTS_DEMO_SHIPPING_DETAILS,
} from '../../data/PricingInsightsDemoData';
import { useShouldShowDemoData } from './price-recommendation/DemoDataUtils';

const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export function PricingInsightsPage() {
  const [shippingDetails, $shippingDetails] =
    useState<ShippingDetailsDTO | null>(null);
  const [pricingInsights, $pricingInsights] =
    useState<PricingInsightsResultDTO | null>(null);
  const { isLimitReached } = useUnlockUtils();
  const [isLocked, $isLocked] = useState(isLimitReached);

  const shippingDetailsQueryParams = useShippingDetailsQueryParams();

  const shouldShowDemoData = useShouldShowDemoData();
  const showDemoData =
    !pricingInsights &&
    shouldShowDemoData &&
    !isLocked &&
    isEmptyFormValues(shippingDetailsQueryParams);

  const handleSubmit = useCallback(
    (values: ShippingDetailsDTO) => {
      if (isLimitReached) {
        $isLocked(true);
      }

      $shippingDetails(values);
    },
    [isLimitReached, $shippingDetails],
  );
  const handleLimitReachedError = useCallback(() => {
    $isLocked(true);
  }, [$isLocked]);

  return (
    <Content>
      <ShippingDetailsForm
        isLocked={isLocked}
        pricingInsights={pricingInsights}
        shippingDetailsQueryParams={shippingDetailsQueryParams}
        onSubmit={handleSubmit}
        onSubmitSuccess={$pricingInsights}
        onLimitReachedError={handleLimitReachedError}
      />

      <PricingRecommendation
        isLocked={isLocked}
        pricingInsights={
          showDemoData ? PRICING_INSIGHTS_DEMO_DATA : pricingInsights
        }
        shippingDetails={
          showDemoData
            ? PRICING_INSIGHTS_DEMO_SHIPPING_DETAILS
            : shippingDetails
        }
        showDemoBanner={showDemoData}
      />
    </Content>
  );
}
